<template>

    <div :class="[!is_enabled ? 'cursor-pointer hover:bg-gray-100' : '', 'group']" @click="clickRow">

        <div class="flex items-center font-bold flex-row justify-between px-4 py-5 sm:p-6">

            <div class="flex flex-grow items-center gap-3">
                <div class="w-12 h-12 rounded-2xl flex items-center justify-center" style="background-color:#20A849;">
                    <img src="/img/freshchat_white.svg" class="h-7 w-7" />
                </div>
                <div class="flex flex-col items-start">
                    <span>Freshchat</span>
                </div>
            </div>
            <div class="flex text-white bg items-center" v-if="trigger">
                <div
                    class="inline-flex items-center px-0 py-2 bg-white border border-transparent rounded-md font-semibold text-xs text-birdie-green uppercase tracking-widest ">
                    Connected
                </div>
            </div>
            <transition name="fade">
                <div class="flex text-blue-500 items-center"
                    :class="{ 'opacity-50 pointer-events-none': !$page.props.canManageSettings }"
                    v-if="expandInfo && !is_enabled">
                    <button-link
                        :link="$page.props.canManageSettings ? 'https://www.freshworks.com/apps/freshchat/screen_recording_by_zest' : '#'"
                        class="" :title="'Connect ' + app_name + ' with Freshchat'">
                        Connect
                    </button-link>
                </div>
            </transition>
        </div>


        <Flows :visible="expandInfo" :fixed="is_enabled" :flows="flows" :docs="docs" :name="name" />

        <!-- <div class="flex items-center font-bold flex-row">
            <div class="flex flex-grow items-center ">
                <img src="/img/freshchat-icon.svg" class="h-6 w-6 mr-2" />
                Freshchat
            </div>
            <div class="flex text-blue-500 items-center" v-if="trigger && trigger.token">
                <vue-feather type="check" class="h-5 w-5 mr-1" ></vue-feather> connected
            </div>
            <div class="flex text-gray-400 items-center" v-else-if="trigger">
                installation incomplete
            </div>
        </div>

        <div class="flex flex-row mt-4" v-if="!trigger">
            <div class="flex items-center flex-grow">
               Install {{app_name}} right from your Freshchat Messaging account.
            </div>
            <div class="flex items-center">
                <button-link
                    link="https://www.freshworks.com/apps/freshchat/screen_recording_by_zest"
                    class=""
                    :title="'Install '+app_name+' on Freshchat'">
                    Install <vue-feather type="arrow-right" class="h-4 w-4 ml-2"></vue-feather>
                </button-link>
            </div>
        </div> -->

        <div class="flex flex-row mt-3" v-if="trigger && !is_modal && !trigger.token">
            <div class="flex items-center flex-grow">
                <span class="text-sm text-yellow-600 font-bold">
                    Installation not complete, did you reload your Freshchat browser tab after installing?
                </span>
            </div>
        </div>

    </div>

</template>

<script>
import Toggle from '@/Components/UI/Toggle'
import ButtonLink from '@/Jetstream/ButtonLink'
import Flows from '@/Components/Settings/Integrations/Flows'
export default {

    props: ['the_trigger', "is_modal", "flows", "docs", "name"],

    components: {
        Toggle, ButtonLink, Flows
    },

    created: function () {
        if (this.the_trigger) {
            this.trigger = this.the_trigger
            this.engine = JSON.parse(this.the_trigger.details)
        }
    },

    data() {
        return {
            trigger: null,
            engine: {},
            app_name: this.$page.props.app_name,
            is_enabled: this.the_trigger != false,
            expandInfo: false
        }
    },

    mounted: function () {
        //console.log(this.trigger);
    },

    methods: {
        clickRow: function () {
            if (this.is_enabled) {
                return
            }
            this.expandInfo = !this.expandInfo
        },
        toggleIntercom: function (checked) {
            this.trigger.enabled = checked ? 1 : 0
            this.updateTrigger()
        },
        toggle: function () {
            if (this.trigger.enabled == 1) {
                this.trigger.enabled = 0;
            } else {
                this.trigger.enabled = 1;
            }
            this.updateTrigger();
        },
        updateTrigger: function () {

            let url = this.$page.props.api_url + '/v1/integration/' + this.trigger.id;
            var params = {
                enabled: this.trigger.enabled
            };
            axios.post(url, params)
                .then(response => {
                    //console.log(response.data);
                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Setting updated", options)
                })
                .catch(e => {
                    console.error(e);
                });
        }
    },

    computed: {
        enabled: {
            get: function () {
                return this.trigger.enabled == 1
            },
            set: function (newValue) {
                // do nothing
            }
        }
    }
}

</script>

<style scoped></style>
